// extracted by mini-css-extract-plugin
export var box = "_45-1";
export var checked = "_45-2";
export var descriptionSpacer = "_45-9";
export var disabled = "_45-3";
export var icon = "_45-6";
export var input = "_45-0";
export var labelSpacer = "_45-8";
export var medium = "_45-5";
export var small = "_45-4";
export var text = "_45-7";